import { Injectable } from '@angular/core';
import { ConfigInterface } from '@core/interfaces';
import { Marcas } from '@core/interfaces/catalogos.intefaces';
import { Request } from '@core/models/requests.model';

@Injectable({
  providedIn: 'root',
})
export class MarcasService {
  private url = `ventas/catalogos/nuevos/marcas/search`;  

  constructor(private request: Request) {}

  getMarcas(body?: any) {
    const config: ConfigInterface = this.request.getConfigUser();
    const requestBody = body ? body : { configuracion: { basesDeDatos: config.basesDeDatos, idioma: config.idioma } };
    const options = { headers: this.request.headers };
    return this.request.Post<Marcas>(this.url, requestBody, options);
  }

  formatValues(data: any[], keyProp: string, valueProp: string): { key: any; value: any }[] {
    return data.map(item => ({ key: item[keyProp], value: item[valueProp] }));
  }
}
